exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calssify-item{width:3.8rem}.calssify-item .category-item{cursor:pointer;padding:.4615rem 0;font-size:.5385rem}.calssify-item .category-item .icon{width:1.7692rem;height:1.7692rem;border-radius:50%;display:block;margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ed1a4f4","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/classify.vue
// module id = m8ar
// module chunks = 25 26 28 29 30 31 32 33 34 35 36 37 38 39 40